import React, { useEffect } from "react";
import Header from "../../components/layout/Header";
import Hero from "../../components/About/hero/Hero";
import Footer from "../../components/layout/Footer";
import { GuideBottom } from "../../components/Home/Guide/Guide";
import ContactForm from "../../components/contact/ContactForm";

function Contact() {
  useEffect(() => {
    window.scrollTo(0, 0);
  });
  return (
    <>
      <Header />
      <Hero heading="Contact Us" />
      <div className="layout-container layout-section">
        <ContactForm />
      </div>
      <section className="layout-section pt-0">
        <div className="layout-container">
          <GuideBottom />
        </div>
      </section>
      <Footer />
    </>
  );
}

export default Contact;
